import { memo } from 'react';

import ClanHubTileContent from './ClanHubTileContent';
import ClanHubTileWithGuidingtip from './ClanHubTileWithGuidingtip';

import type { HubTileModel } from '../clanHub.tiles.build';
import type { ROLE_NAMES } from '~/roles';

export enum CLAN_HUB_TILE_SIZE {
  SMALL = 'small',
  LARGE = 'large',
}

interface ClanHubTileProps {
  tile: HubTileModel;
  size: CLAN_HUB_TILE_SIZE;
  isClanMember?: boolean;
  currentRoleName?: ROLE_NAMES | null;
  onClick?: () => void;
}

const ClanHubTile = ({ tile, size, isClanMember = false, currentRoleName = null, onClick }: ClanHubTileProps) => {
  if (tile.onboarding && isClanMember) {
    return <ClanHubTileWithGuidingtip tile={tile} size={size} currentRoleName={currentRoleName} onClick={onClick} />;
  }

  return <ClanHubTileContent tile={tile} size={size} currentRoleName={currentRoleName} onClick={onClick} />;
};

export default memo(ClanHubTile);
